import { Alert, Box, FormControl, TextField } from "@mui/material";
import localize from "../../common/localize";
import { getInputLabelProps, getInputProps } from "../../common/appStyles";
import { useEffect, useState } from "react";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../common/utils";
import { MovementTypeEnum } from "../../common/EntitiesManagement";

export default function SupplyQuantity({
  supply,
  quantity,
  setQuantity,
  movementType,
  detailObservation,
  setDetailObservation,
}) {
  const maximumCharactersForDescription =
    MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;
  const [detailObservationCount, setDetailObservationCount] = useState(0);

  const handleChangeDetailObservation = (e) => {
    setDetailObservation(e.target.value);
  };

  useEffect(() => {
    if (detailObservation) {
      setDetailObservationCount(detailObservation.length);
    }
  }, [detailObservation]);

  const getQuantityValue = (currentValue, supplyQuantity) => {
    console.log(
      `MovementType: ${movementType}, Value: ${currentValue}, Supply: ${supplyQuantity}`
    );
    if (!currentValue || currentValue <= 0) {
      return 1;
    }

    if (
      supplyQuantity > 0 &&
      movementType === MovementTypeEnum.Out &&
      currentValue > supplyQuantity
    ) {
      return supplyQuantity;
    }

    return currentValue;
  };

  return (
    <Box className="flex flex-col gap-2 my-2" sx={{ width: "400px" }}>
      <Box className="two_columns_grid">
        <label className="field_title_text">
          <b>{`${localize.code}:`}</b>
        </label>
        <label className="field_title_text">{supply.Code}</label>
        <label className="field_title_text">
          <b>{`${localize.name}:`}</b>
        </label>
        <label className="field_title_text">{supply.Name}</label>
        <label className="field_title_text">
          <b>{`${localize.quantity}:`}</b>
        </label>
        <label className="field_title_text">{supply.Quantity}</label>
      </Box>

      {supply.Quantity === 0 && movementType === MovementTypeEnum.Out ? (
        <Alert className="w-full" severity="error">
          {localize.there_is_no_supplies_on_warehouse}
        </Alert>
      ) : (
        <Box className="w-full flex flex-col gap-4">
          <TextField
            type="number"
            InputLabelProps={getInputLabelProps()}
            inputProps={getInputProps()}
            value={quantity}
            onChange={(e) => {
              setQuantity(getQuantityValue(e.target.value, supply.Quantity));
            }}
            size="small"
            id="Quantity"
            name="Quantity"
            variant="outlined"
            fullWidth
          />

          <FormControl fullWidth>
            <TextField
              InputLabelProps={getInputLabelProps()}
              inputProps={{
                style: {
                  fontSize: "0.8em",
                },
                maxLength: maximumCharactersForDescription,
              }}
              size="small"
              fullWidth
              multiline
              rows={3}
              id="outlined-basic"
              name="Observation"
              label={localize.observations}
              variant="outlined"
              onChange={handleChangeDetailObservation}
              value={detailObservation}
              helperText={`${detailObservationCount}/${maximumCharactersForDescription}`}
            />
          </FormControl>
        </Box>
      )}
    </Box>
  );
}
